import { useQuery } from "@tanstack/react-query";
import { fetchEOL } from "@/utils/dashboardFetch";

export const useEOLQuery = () => {
    return useQuery({
        queryKey: ['eol'],
        queryFn: fetchEOL,
        staleTime: 1000 * 60 * 60 * 24, // 24 hours (EOL varies slowly)
    });
};
